import { render, staticRenderFns } from "./MeasuredValuesView.vue?vue&type=template&id=00f342be&scoped=true&"
import script from "./MeasuredValuesView.vue?vue&type=script&lang=ts&"
export * from "./MeasuredValuesView.vue?vue&type=script&lang=ts&"
import style0 from "./MeasuredValuesView.vue?vue&type=style&index=0&id=00f342be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f342be",
  null
  
)

export default component.exports